import SpeedIcon from "@mui/icons-material/Speed";
import {BoltOutlined, ClearAll, Deblur, LineWeight, UnfoldLessDoubleOutlined, Fingerprint, Mode} from "@mui/icons-material";
import Boxel from "../Icons/Boxel.tsx";

export interface MeasurementIconProps {
    icon: string;
}

export function MeasurementIcon(props: MeasurementIconProps) {

    let {icon} = props;

    icon = icon.toLowerCase();

    if (/fit/.test(icon)) {
        return <UnfoldLessDoubleOutlined/>;
    }
    if (/thickness/.test(icon)) {
        return <LineWeight/>;
    }
    if (/speed/.test(icon)) {
        return <SpeedIcon/>;
    }
    if (/power/.test(icon)) {
        return <BoltOutlined/>;
    }
    if (/focus_offset/.test(icon)) {
        return <Deblur/>;
    }
    if (/passes/.test(icon)) {
        return <ClearAll/>;
    }
    if (/target/.test(icon)) {
        return <Fingerprint/>;
    }
    if (/mode/.test(icon)) {
        return <Mode/>;
    }
    return <Boxel/>;
}